import { Builder } from "@builder.io/react";
import { getCurrentPageType } from "@/helpers/generalHelper";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// const carouselTypeValues = [
//   "Recommended for you carousel",
//   "Bestsellers carousel",
// ];
// const nostoIdPDP = ["productpage-nosto-1", "productpage-nosto-2"];
// const nostoIdPLP = [
//   "categorypage-nosto-1",
//   "frontpage-nosto-1-copy-copy-1-copy",
// ];
// const nostoIdHome = ["frontpage-nosto-1", "frontpage-nosto-2"];
// const nostoIdEditorial = [
//   "Editorial Recommended for you carousel",
//   "Editorial Bestsellers carousel",
// ];

export const NostoProductCarousel = ({ carouselType }) => {
  const [nostoPlaceHolder, setNostoPlaceHolder] = useState("");
  const nostoPlacements = useSelector((state) => state.nosto.nostoPlacements);
  const getNostoPlaceholder = async (carouselType) => {
    //const pageType = await getCurrentPageType();
    let nostoId = "",
      nostoPlaceHolder = "";
    //const carouselIndex = carouselTypeValues.indexOf(carouselType);
    // switch (pageType) {
    //   case "pdp":
    //     nostoId = nostoIdPDP[carouselIndex];
    //     break;
    //   case "home":
    //     nostoId = nostoIdHome[carouselIndex];
    //     break;
    //   case "editorial":
    //     nostoId = nostoIdEditorial[carouselIndex];
    //     break;
    //   default:
    //     nostoId = nostoIdPLP[carouselIndex];
    // }
    const carouselValue = carouselType;
    nostoPlaceHolder = (
      <>
        <div
          className="nosto_element"
          id={carouselValue}
          dangerouslySetInnerHTML={{
            __html: nostoPlacements[carouselValue] ? nostoPlacements[carouselValue] : "",
          }}
        ></div>
      </>
    );
    setNostoPlaceHolder(nostoPlaceHolder);
  };

  useEffect(() => {
    getNostoPlaceholder(carouselType);
  }, [carouselType]);

  return <>{nostoPlaceHolder}</>;
};

Builder.registerComponent(NostoProductCarousel, {
  name: "Automated carousel",
  inputs: [
    {
      name: "carouselType",
      type: "string",
      //enum: carouselTypeValues,
      helperText: "Enter the HTML placeholder that can be found within the placement",
    },
  ],
});
